import { Component, Input, OnInit } from "@angular/core";
import { Global } from "src/app/global";
import { ApiService } from "src/app/service/apiServices";
import Swal from "sweetalert2";

@Component({
  selector: "app-documento-externo",
  templateUrl: "./documento-externo.component.html",
  styleUrls: ["./documento-externo.component.css"],
})
export class DocumentoExternoComponent implements OnInit {
  @Input() documentos: any[] = [];
  @Input() telaAtendimento: boolean = true;

  global_: any;
  tiposDocumento = [
    { label: "Receituário", value: 1 },
    { label: "Atestado", value: 2 },
    { label: "Declaração", value: 3 },
    { label: "Exame", value: 4 },
    { label: "Laudo", value: 10 },
  ];

  constructor(private global: Global, public service: ApiService) {
    this.global_ = this.global;
  }

  ngOnInit() {}

  getExtensao(nomeArquivo: string): string {
    if (!nomeArquivo) return "";

    const partes = nomeArquivo.split(".");
    return partes.length > 1 ? partes[partes.length - 1].toLowerCase() : "";
  }
  getTipoDocumento(tipo: number): string {
    if (!tipo) return "";

    const tipoDocumento = this.tiposDocumento.find((t) => t.value === tipo);
    return tipoDocumento ? tipoDocumento.label.toUpperCase() : "";
  }

  deletarArquivo(id: number, cidadao_id: number) {
    this.service.Delete(`DocumentoExterno/${id}/cidadao/${cidadao_id}`).then(

      (result) => {

        var documento = this.documentos.find(
          (doc) => doc.id === id
        );
        const path = `Arquivo/DeletarDocumentoExternoPaciente/${documento.cidadao_uuid}/${documento.nome_arquivo}`;
              this.service.Delete(path).then(() => {
                Swal.fire({
                  title: "Sucesso!",
                  text: "Arquivo deletado com sucesso.",
                  icon: "success",
                  confirmButtonText: "OK",
                });

                this.documentos = this.documentos.filter(
                  (doc) => doc.id !== id
                );
                
              Swal.close();
            });

      })
  }  

  downloadDocumento(documento_nome: string, cidadao_uuid: string) {
    const path = `Arquivo/Download/DocumentoExternoPaciente/${cidadao_uuid}/${documento_nome}`;
    try {
       this.service.GetFile(path);
     
    } catch (error) {
      Swal.fire("Error", error.error.messagem, "error");
    }
  }
  enviarMsg(documento:any){

    const request = {
      "atendimento_id": documento.atendimento_id,
      "file_name": documento.nome_arquivo,
      "uuid_cidadao": documento.cidadao_uuid
    }

    this.service.Post("DocumentoExterno/Whatsapp", request).then((result) => {
      Swal.fire({
        title: "Sucesso!",
        text: "Arquivo enviado com sucesso.",
        icon: "success",
        confirmButtonText: "OK",
      });
    }).catch((error) => {
      Swal.fire("Error", "Erro ao tentar enviar mensagem", "error");
    });
  }
}
